import { render, staticRenderFns } from "./ClaimTypeLookup.vue?vue&type=template&id=3311abc8&lang=pug"
import script from "./ClaimTypeLookup.vue?vue&type=script&lang=js"
export * from "./ClaimTypeLookup.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports